import {
  ActionDto,
  ActionPropertyDto,
  BaseModel,
  BaseModelBulkItemModel,
  DefaultEventActionInputDto,
  DtoPropertyDto,
  EventActionDto,
  EventActionTemplateDto,
  EventActionTemplateDtoApiResponse,
  EventActionTemplateModel,
  EventDataSourceDto,
  EventDto,
  EventPropertyDto,
  ExecutionActionItemDto,
  ExecutionDto,
  GetActionByidQueryParams,
  GetActionPropertyByidQueryParams,
  GetActionPropertyQueryParams,
  GetActionQueryParams,
  GetDefaultEventActionInputQueryParams,
  GetDefaultEventActionTemplateQueryParams,
  GetDtoPropertyQueryParams,
  GetEventActionByidQueryParams,
  GetEventActionQueryParams,
  GetEventActionTemplateByidQueryParams,
  GetEventActionTemplateQueryParams,
  GetEventByidQueryParams,
  GetEventDataSourceByidQueryParams,
  GetEventDataSourceQueryParams,
  GetEventPropertyByidQueryParams,
  GetEventPropertyQueryParams,
  GetEventQueryParams,
  GetExecutionActionQueryParams,
  GetExecutionQueryParams,
  GetPropertyTypeQueryParams,
  GetRuleByidQueryParams,
  GetRuleProfileByidQueryParams,
  GetRuleProfileCategoryCountQueryParams,
  GetRuleProfileCategoryEventQueryParams,
  GetRuleProfileQueryParams,
  GetRuleQueryParams,
  GetServiceQueryParams,
  GetTriggerTypeQueryParams,
  PropertyTypeDto,
  RuleActiveModelBulkItemModel,
  RuleDto,
  RuleDtoApiResponse,
  RuleDtoApiResponseListApiResponse,
  RuleListItemDto,
  RuleModel,
  RuleModelBulkItemModel,
  RuleProfileCategoryDto,
  RuleProfileCategoryEventDto,
  RuleProfileDto,
  RuleProfileDtoApiResponse,
  RuleProfileDtoApiResponseListApiResponse,
  RuleProfileModel,
  SeedDefaultRuleModel,
  ServiceDto,
  TriggerTypeDto
} from 'src/models/automation';
import { GetAxiosInstance } from '../baseService';
import { ServiceLocation } from '../serviceLocationsAxios';
import { AxiosRequestConfig } from 'axios';

/**
 * Get Rule Profiles
 * @param params GetRuleProfileQueryParams
 * @returns RuleProfileDto[]
 */
export const getRuleProfiles = async (params?: GetRuleProfileQueryParams) => {
  return GetAxiosInstance().get<RuleProfileDto[]>(ServiceLocation.automation + '/RuleProfile', { params });
};

/**
 * Get Rule Profile by Id
 * @param id Id of the Rule profile
 * @param params GetRuleProfileByidQueryParams
 * @returns RuleProfileDto
 */
export const getRuleProfileById = async (id: string, params?: GetRuleProfileByidQueryParams) => {
  return GetAxiosInstance().get<RuleProfileDto>(ServiceLocation.automation + '/RuleProfile/' + id, { params });
};

/**
 * Post Rule Profile
 * @param model
 * @returns
 */
export const postRuleProfile = async (model: RuleProfileModel) => {
  return GetAxiosInstance().post<RuleProfileDtoApiResponse>(ServiceLocation.automation + '/RuleProfile', model);
};

/**
 * Put Rule Profile
 * @param id Id of the Rule Profile
 * @param model RuleProfileModel
 * @returns RuleProfileDtoApiResponse
 */
export const putRuleProfile = async (id: string, model: RuleProfileModel) => {
  return GetAxiosInstance().put<RuleProfileDtoApiResponse>(ServiceLocation.automation + '/RuleProfile/' + id, model);
};

/**
 * Get Rule Profile Categories
 * @param params GetRuleProfileCategoryCountQueryParams
 * @returns RuleProfileCategoryDto[]
 */
export const getRuleProfileCategories = async (params?: GetRuleProfileCategoryCountQueryParams) => {
  return GetAxiosInstance().get<RuleProfileCategoryDto[]>(ServiceLocation.automation + '/RuleProfileCategory', {
    params
  });
};

/**
 * Get Rule Profile Category Events
 * @param params GetRuleProfileCategoryEventQueryParams
 * @returns RuleProfileCategoryEventDto[]
 */
export const getRuleProfileCategoryEvents = async (params?: GetRuleProfileCategoryEventQueryParams) => {
  return GetAxiosInstance().get<RuleProfileCategoryEventDto[]>(
    ServiceLocation.automation + '/RuleProfileCategoryEvent',
    { params }
  );
};

/**
 * Get Rules
 * @param params GetRuleQueryParams
 * @returns RuleListItemDto[]
 */
export const getRules = async (params?: GetRuleQueryParams) => {
  return GetAxiosInstance().get<RuleListItemDto[]>(ServiceLocation.automation + '/Rule', { params });
};

/**
 * Get Rule by Id
 * @param id Id of the Rule
 * @param params GetRuleByidQueryParams
 * @returns RuleDto
 */
export const getRuleById = async (id: string, params?: GetRuleByidQueryParams) => {
  return GetAxiosInstance().get<RuleDto>(ServiceLocation.automation + '/Rule/' + id, { params });
};

/**
 * Post Rule
 * @param model RuleModel
 * @returns RuleDtoApiResponse
 */
export const postNotificationDefaults = async (model: SeedDefaultRuleModel) => {
  return GetAxiosInstance().post<RuleDtoApiResponse>(ServiceLocation.automation + '/RuleProfile/defaults', model);
};

/**
 * Post Rule
 * @param model RuleModel
 * @returns RuleDtoApiResponse
 */
export const postRule = async (model: RuleModel) => {
  return GetAxiosInstance().post<RuleDtoApiResponse>(ServiceLocation.automation + '/Rule', model);
};

/**
 * Put Rule
 * @param id Id of the Rule
 * @param model RuleModel
 * @returns RuleDtoApiResponse
 */
export const putRule = async (id: string, model: RuleModel) => {
  return GetAxiosInstance().put<RuleDtoApiResponse>(ServiceLocation.automation + '/Rule/' + id, model);
};

/**
 * Delete Rule
 * @param id Id of the Rule
 * @param model Delete Model
 * @returns RuleDtoApiResponse
 */
export const deleteRule = async (id: string, model: any) => {
  const reqBody: AxiosRequestConfig<RuleDtoApiResponse> = {
    data: model
  };

  return GetAxiosInstance().delete<RuleDtoApiResponse>(ServiceLocation.automation + '/Rule/' + id, reqBody);
};

/**
 * Get Execution
 * @param params GetExecutionQueryParams
 * @returns ExecutionDto[]
 */
export const getExecution = async (params?: GetExecutionQueryParams) => {
  return GetAxiosInstance().get<ExecutionDto[]>(ServiceLocation.automation + '/Execution', { params });
};

/**
 * Get Execution Action
 * @param params GetExecutionActionQueryParams
 * @returns ExecutionActionItemDto[]
 */
export const getExecutionActions = async (params?: GetExecutionActionQueryParams) => {
  return GetAxiosInstance().get<ExecutionActionItemDto[]>(ServiceLocation.automation + '/ExecutionAction', { params });
};

/**
 * Get Events
 * @param params GetEventQueryParams
 * @returns EventDto[]
 */
export const getEvents = async (params?: GetEventQueryParams) => {
  return GetAxiosInstance().get<EventDto[]>(ServiceLocation.automation + '/Event', { params });
};

/**
 * Get Event by Id
 * @param id Id of the Event
 * @param params GetEventByidQueryParams
 * @returns EventDto
 */
export const getEventById = async (id: string, params?: GetEventByidQueryParams) => {
  return GetAxiosInstance().get<EventDto>(ServiceLocation.automation + '/Event/' + id, { params });
};

/**
 * Get Event Actions
 * @param params GetEventActionQueryParams
 * @returns EventActionDto[]
 */
export const getEventActions = (params?: GetEventActionQueryParams) => {
  return GetAxiosInstance().get<EventActionDto[]>(ServiceLocation.automation + '/EventAction', { params });
};

/**
 * Get Event Action by Id
 * @param id Id of the Event Action
 * @param params GetEventActionByidQueryParams
 * @returns EventActionDto
 */
export const getEventActionById = (id: string, params?: GetEventActionByidQueryParams) => {
  return GetAxiosInstance().get<EventActionDto>(ServiceLocation.automation + '/EventAction/' + id, { params });
};

/**
 * Get Event Data Sources
 * @param params GetEventDataSourceQueryParams
 * @returns EventDataSourceDto[]
 */
export const getEventDataSources = (params?: GetEventDataSourceQueryParams) => {
  return GetAxiosInstance().get<EventDataSourceDto[]>(ServiceLocation.automation + '/EventDataSource', { params });
};

/**
 * Get Event Data Source by Id
 * @param id Id of the Event Data Source
 * @param params GetEventDataSourceByidQueryParams
 * @returns EventDataSourceDto
 */
export const getEventDataSourceById = (id: string, params?: GetEventDataSourceByidQueryParams) => {
  return GetAxiosInstance().get<EventDataSourceDto>(ServiceLocation.automation + '/EventDataSource/' + id, { params });
};

/**
 * Get Event Properties
 * @param params GetEventPropertyQueryParams
 * @returns EventPropertyDto[]
 */
export const getEventProperties = (params?: GetEventPropertyQueryParams) => {
  return GetAxiosInstance().get<EventPropertyDto[]>(ServiceLocation.automation + '/EventProperty', { params });
};

/**
 * Get Event Property by Id
 * @param id Id of the Event Property
 * @param params GetEventPropertyByidQueryParams
 * @returns EventPropertyDto
 */
export const getEventPropertyById = (id: string, params?: GetEventPropertyByidQueryParams) => {
  return GetAxiosInstance().get<EventPropertyDto>(ServiceLocation.automation + '/EventProperty/' + id, { params });
};

/**
 * Get Actions
 * @param params GetActionQueryParams
 * @returns ActionDto[]
 */
export const getActions = (params?: GetActionQueryParams) => {
  return GetAxiosInstance().get<ActionDto[]>(ServiceLocation.automation + '/Action', { params });
};

/**
 * Get Action by Id
 * @param id Id of the Action
 * @param params GetActionByidQueryParams
 * @returns ActionDto
 */
export const getActionById = (id: string, params?: GetActionByidQueryParams) => {
  return GetAxiosInstance().get<ActionDto>(ServiceLocation.automation + '/Action/' + id, { params });
};

/**
 * Get Action Properties
 * @param params GetActionPropertyQueryParams
 * @returns ActionPropertyDto[]
 */
export const getActionProperties = (params?: GetActionPropertyQueryParams) => {
  return GetAxiosInstance().get<ActionPropertyDto[]>(ServiceLocation.automation + '/ActionProperty', { params });
};

/**
 * Get Action Property by Id
 * @param id Id of the Action Property
 * @param params GetActionPropertyByidQueryParams
 * @returns ActionPropertyDto
 */
export const getActionPropertyById = (id: string, params?: GetActionPropertyByidQueryParams) => {
  return GetAxiosInstance().get<ActionPropertyDto>(ServiceLocation.automation + '/ActionProperty/' + id, { params });
};

/**
 * Get Default Event Action Inputs
 * @param params GetDefaultEventActionInputQueryParams
 * @returns DefaultEventActionInputDto[]
 */
export const getDefaultEventActionInputs = (params?: GetDefaultEventActionInputQueryParams) => {
  return GetAxiosInstance().get<DefaultEventActionInputDto[]>(ServiceLocation.automation + '/DefaultEventActionInput', {
    params
  });
};

/**
 * Get Trigger Types
 * @param params GetTriggerTypeQueryParams
 * @returns TriggerTypeDto[]
 */
export const getTriggerTypes = (params?: GetTriggerTypeQueryParams) => {
  return GetAxiosInstance().get<TriggerTypeDto[]>(ServiceLocation.automation + '/TriggerType', { params });
};

/**
 * Get Dto Properties
 * @param params GetDtoPropertyQueryParams
 * @returns DtoPropertyDto[]
 */
export const getDtoProperties = (params?: GetDtoPropertyQueryParams) => {
  return GetAxiosInstance().get<DtoPropertyDto[]>(ServiceLocation.automation + '/DtoProperty', { params });
};

/**
 * Get Property Types
 * @param params GetPropertyTypeQueryParams
 * @returns PropertyTypeDto[]
 */
export const getPropertyTypes = (params?: GetPropertyTypeQueryParams) => {
  return GetAxiosInstance().get<PropertyTypeDto[]>(ServiceLocation.automation + '/PropertyType', { params });
};

/**
 * Get Services
 * @param params GetServiceQueryParams
 * @returns ServiceDto[]
 */
export const getServices = (params?: GetServiceQueryParams) => {
  return GetAxiosInstance().get<ServiceDto[]>(ServiceLocation.automation + '/Service', { params });
};

/**
 * Bulk Rule Toggle Status
 * @param models RuleActiveModelBulkItemModel[]
 * @returns RuleDtoApiResponseListApiResponse
 */
export const bulkRuleToggleStatus = (model: RuleActiveModelBulkItemModel[]) => {
  return GetAxiosInstance().patch<RuleDtoApiResponseListApiResponse>(
    ServiceLocation.automation + '/Rule/activate',
    model
  );
};

/**
 * Bulk Delete Rules
 * @param models BaseModelBulkItemModel[]
 * @returns RuleDtoApiResponseListApiResponse
 */
export const bulkDeleteRules = (models: BaseModelBulkItemModel[]) => {
  const reqBody: AxiosRequestConfig<BaseModelBulkItemModel[]> = {
    data: models
  };

  return GetAxiosInstance().delete<RuleDtoApiResponseListApiResponse>(ServiceLocation.automation + '/Rule', reqBody);
};

/**
 * Delete Rule Profile by Id
 * @param id Id of the Rule Profile
 * @param model BaseModel
 * @returns RuleProfileDtoApiResponse
 */
export const deleteRuleProfile = (id: string, model: BaseModel) => {
  const reqBody: AxiosRequestConfig<BaseModel> = {
    data: model
  };

  return GetAxiosInstance().delete<RuleProfileDtoApiResponse>(
    ServiceLocation.automation + '/RuleProfile/' + id,
    reqBody
  );
};

/**
 * Bulk Put Rules
 * @param models RuleModelBulkItemModel[]
 * @returns RuleDtoApiResponseListApiResponse
 */
export const bulkPutRules = (models: RuleModelBulkItemModel[]) => {
  return GetAxiosInstance().put<RuleDtoApiResponseListApiResponse>(ServiceLocation.automation + '/Rule', models);
};

/**
 * Post Event Action Template
 * @param model EventActionTemplateModel
 * @returns EventActionTemplateDtoApiResponse
 */
export const postEventActionTemplate = (model: EventActionTemplateModel) => {
  return GetAxiosInstance().post<EventActionTemplateDtoApiResponse>(
    ServiceLocation.automation + '/EventActionTemplate',
    model
  );
};

/**
 * Put Event Action Template
 * @param id Id of the Event Action Template
 * @param model EventActionTemplateModel
 * @returns EventActionTemplateDtoApiResponse
 */
export const putEventActionTemplate = (id: string, model: EventActionTemplateModel) => {
  return GetAxiosInstance().put<EventActionTemplateDtoApiResponse>(
    ServiceLocation.automation + '/EventActionTemplate/' + id,
    model
  );
};

/**
 * Delete Event Action Template
 * @param id Id of the Event Action Template
 * @param model BaseModel
 * @returns EventActionTemplateDtoApiResponse
 */
export const deleteEventActionTemplate = (id: string, model: BaseModel) => {
  const reqBody: AxiosRequestConfig<BaseModel> = {
    data: model
  };

  return GetAxiosInstance().delete<EventActionTemplateDtoApiResponse>(
    ServiceLocation.automation + '/EventActionTemplate/' + id,
    reqBody
  );
};

/**
 * Get Event Action Templates
 * @param params GetEventActionTemplateQueryParams
 * @returns EventActionTemplateDto[]
 */
export const getEventActionTemplates = (
  params?: GetEventActionTemplateQueryParams,
  tenantId?: string,
  partnerId?: string
) => {
  return GetAxiosInstance(undefined, tenantId, partnerId).get<EventActionTemplateDto[]>(
    ServiceLocation.automation + '/EventActionTemplate',
    { params }
  );
};

/**
 * Get Event Action Template by Id
 * @param id Id of the Event Action Template
 * @param params GetEventActionTemplateByidQueryParams
 * @returns EventActionTemplateDto
 */
export const getEventActionTemplateById = (id: string, params?: GetEventActionTemplateByidQueryParams) => {
  return GetAxiosInstance().get<EventActionTemplateDto>(ServiceLocation.automation + '/EventActionTemplate/' + id, {
    params
  });
};

/**
 * Get Default Event Action Templates
 * @param params GetDefaultEventActionTemplateQueryParams
 * @returns EventActionTemplateDto[]
 */
export const getDefaultEventActionTemplates = (params?: GetDefaultEventActionTemplateQueryParams) => {
  return GetAxiosInstance().get<EventActionTemplateDto[]>(ServiceLocation.automation + '/DefaultEventActionTemplate', {
    params
  });
};

/**
 * Bulk Delete Rule Profiles
 * @param models BaseModelBulkItemModel[]
 * @returns RuleProfileDtoApiResponseListApiResponse
 */
export const bulkDeleteRuleProfiles = (models: BaseModelBulkItemModel[]) => {
  const reqBody: AxiosRequestConfig<BaseModelBulkItemModel[]> = {
    data: models
  };

  return GetAxiosInstance().delete<RuleProfileDtoApiResponseListApiResponse>(
    ServiceLocation.automation + '/RuleProfile',
    reqBody
  );
};
